import { useState, useEffect } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { useParams } from "react-router";
import Swal from "sweetalert2";
import { eiwrsRandomizationSchemaServices } from "../../../APIServices/EIWRS/eiwrsRandomizationSchemaServices";
import { studySubjectManagementServices } from "../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";

const ReplaceRandomization = ({
  Show,
  Hide,
  Title,
  subjectData,
  getStudySiteSubjectRandomizationData,
}) => {
  const [randomizerLoader, setRandomizerLoader] = useState(false);
  const [subjectLoader, setSubjectLoader] = useState(false);
  const [subjectList, setSubjectList] = useState([]);
  const [replaceSubjectId, setReplaceSubjectId] = useState("");
  const { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const getStudySiteSubjectList = async () => {
    setSubjectLoader(true)
    let data = await studySubjectManagementServices.getStudySiteSubjectRandomizationData("replace", studyId, "no", LoginCat, StudyMode)
    if(subjectData?.level === "studyLevel"){
      setSubjectList(data?.data || [])
    }else{
      let result = data?.data || []
      let filteredData = result?.filter(item => item.siteId === subjectData?.siteId)
      setSubjectList(filteredData)
    }
    setSubjectLoader(false)
  }

  useEffect(() => {
    if(subjectData?.level){
      getStudySiteSubjectList();
    }
  }, [subjectData?.level]);

  const replaceSubjectRandomization = async (schemaId, siteId, subjectId) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Subject Randomization!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Randomized it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setRandomizerLoader(true)
        let userData = {}
        userData.studyId = studyId
        userData.siteId = subjectData?.siteId
        userData.subjectId = subjectData?.subjectId
        userData.mode = StudyMode
        userData.replaceSubjectId = replaceSubjectId
        let data = await eiwrsRandomizationSchemaServices.replaceSubjectRandomization(userData)
        if (data?.statusCode === 200) {
          getStudySiteSubjectList()
          getStudySiteSubjectRandomizationData()
          Hide()
        }
        setRandomizerLoader(false)
      }
    });
  };
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {subjectLoader ? (
          <PageLoader />
        ) :
          <Form.Group className="mb-3">
            <Form.Label className="mb-1 fw-semibold">
              Subject <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              onChange={(e) => setReplaceSubjectId(e.target.value)}
              style={{ fontSize: 12 }}
              className="br3"
              disabled={subjectList?.length === 0}
              value={replaceSubjectId}
            >
              <option value="">Select Subject</option>
              {subjectList?.map((item => (
                <option value={item?.subjectId}>
                  {item?.row?.SCREENID || item?.row?.SUBJECTID}
                </option>
              )))}
            </Form.Select>
          </Form.Group>
        }
      </Offcanvas.Body>
      <div className="p-2 border-top bg-light text-end">
        <button
          disabled={!replaceSubjectId || randomizerLoader}
          className="updateProfile"
          onClick={replaceSubjectRandomization}
        >
          {randomizerLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Replacing...
            </div>
          ) : (
            "Replace"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default ReplaceRandomization;
